<div class="flex">
  <h2 class="mx-auto text-3xl text-gray-700 font-semibold">Passwort zurücksetzen</h2>
</div>
<div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm flex flex-col">
  @if (error === undefined) {
    <form class="space-y-6" action="#" method="POST">
      <div>
        <label for="password" class="block text-sm font-medium leading-6 text-gray-900">Passwort</label>
        <div class="mt-2 relative">
          <input #password_input id="password" name="password" type="password" autocomplete="password" required
                 [(ngModel)]="password"
                 class="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 !pr-10">
          <app-password-eye [target]="password_input" class="absolute h-6 w-6 right-1.5 top-1.5"></app-password-eye>
        </div>
      </div>

      <app-password-check [(isValid)]="valid" [password]="password" [confirmation]="confirmation"></app-password-check>

      <div>
        <label for="password-confirmation" class="block text-sm font-medium leading-6 text-gray-900">Passwort
          wiederholen</label>
        <div class="mt-2 relative">
          <input #confirmation_input id="password-confirmation" name="password-confirmation" type="password"
                 autocomplete="password"
                 required
                 [(ngModel)]="confirmation"
                 class="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6">
          <app-password-eye [target]="confirmation_input" class="absolute h-6 w-6 right-1.5 top-1.5"></app-password-eye>
        </div>
      </div>

      <!-- Named before the password is chosen, not after: somebody who has lost their phone as well as their
           password needs to know a reset alone will not get them in, while they can still stop and look for
           their recovery code. -->
      @if (isAccount) {
        <p class="text-xs text-gray-500">
          Eine eingerichtete Zwei-Faktor-Authentifizierung bleibt bestehen und wird beim nächsten Anmelden
          weiterhin abgefragt.
        </p>
      }

      <div>
        <button type="submit" (click)="reset()" [disabled]="!valid"
                class="bg-theme-primary-700 hover:bg-theme-primary-900 flex w-full justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:bg-gray-400 disabled:opacity-25">
          Passwort zurücksetzen
        </button>
      </div>
    </form>
  } @else {
    <div class="flex flex-col gap-2 mx-auto text-center">
      <div class="flex flex-col gap-x-1 sm:flex-row">
        <!-- Was "Feher:". -->
        <span class="text-red-600 text-lg font-semibold">Fehler:</span>
        <span class="place-self-center text-lg">
          @if (error == ErrorType.InvalidToken) {
            Token ungültig.
          } @else if (error == ErrorType.ExpiredToken) {
            Token abgelaufen, bitte erneut anfordern.
          } @else {
            URL ungültig.
          }
        </span>
      </div>
      <!-- The link carries the kind across. An expired native link that sent somebody to the employee form
           would have them ask the wrong store for a mail that never arrives — with a 200 and a reassuring
           banner in between, so nothing would ever tell them. -->
      <a [href]="requestAgainLink"
         class="text-theme-primary-700 hover:text-theme-primary-900 font-semibold">
        Neuen Link anfordern
      </a>
    </div>
  }
</div>
